var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("mortgage-selector", {
    attrs: {
      mortgage: _vm.currentFeesMortgageType,
      "disabled-mortgages": _vm.notRequestedMortgages,
    },
    on: {
      "update:mortgage": function ($event) {
        _vm.currentFeesMortgageType = $event
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }